export default (convertedData, groups) => {
  Object.keys(groups).forEach((group, index) => {
    convertedData.splice(groups[group].from, 0, {
      brands: [
        {key: 1, value: convertedData.find(item => item.created_at === group * 1).dataComp[0]},
        {key: 2, value: convertedData.find(item => item.created_at === group * 1).dataComp[1]},
        {key: 3, value: convertedData.find(item => item.created_at === group * 1).dataComp[2]},
        {key: 4, value: convertedData.find(item => item.created_at === group * 1).dataComp[3]},
        {key: 5, value: convertedData.find(item => item.created_at === group * 1).dataComp[4]},
        {key: 6, value: convertedData.find(item => item.created_at === group * 1).dataComp[5]},
        {key: 7, value: convertedData.find(item => item.created_at === group * 1).dataComp[6]},
        {key: 8, value: convertedData.find(item => item.created_at === group * 1).dataComp[7]},
        {key: 9, value: convertedData.find(item => item.created_at === group * 1).dataComp[8]},
        {key: 10, value: convertedData.find(item => item.created_at === group * 1).dataComp[9]},
      ],
      created_at: group * 1,
      created_by: convertedData.find(item => item.created_at === group * 1).created_by,
      data_freq: convertedData.find(item => item.created_at === group * 1).data_freq,
      freq: convertedData.find(item => item.created_at === group * 1).freq,
      index: group.from,
      level: convertedData.find(item => item.created_at === group * 1).level,
      price: convertedData.find(item => item.created_at === group * 1).price,
      project: convertedData.find(item => item.created_at === group * 1).project,
      sow: "DataComp",
      updated_at: group * 1,
      version: 1,
    });
    convertedData.splice(groups[group].from, 0, {
      brands: [
        {key: 1, value: 0},
        {key: 2, value: 1},
        {key: 3, value: 1},
        {key: 4, value: 1},
        {key: 5, value: 0},
        {key: 6, value: 0},
        {key: 7, value: 0},
        {key: 8, value: 0},
        {key: 9, value: 0},
        {key: 10, value: 0},
      ],
      created_at: group * 1,
      created_by: convertedData.find(item => item.created_at === group * 1).created_by,
      data_freq: convertedData.find(item => item.created_at === group * 1).data_freq,
      freq: convertedData.find(item => item.created_at === group * 1).freq,
      index: group.from,
      level: convertedData.find(item => item.created_at === group * 1).level,
      price: convertedData.find(item => item.created_at === group * 1).price,
      project: convertedData.find(item => item.created_at === group * 1).project,
      sow: "Title",
      updated_at: group * 1,
      version: 1,
    });
  });
  return convertedData;
}